module.exports = __webpack_public_path__ + "static/media/sync-circle.fe7d6a1c.svg";